<!--
 * @Author: 
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-07-09 11:12:30
 * @Description: 登录按钮（仅用于调试）
-->
<template>
    <div class="flex">
        <ButtonThe3DButton
            color="blue"
            class="login"
            @click="onLoginClick(true)"
        >
            登录 (仅调试可见)
        </ButtonThe3DButton>
        <!-- 👇登录弹窗 -->
        <Modal
            v-model="globalStore.loginDialogIsOpen"
            containerClass="!p-0 w-[490px] bg-transparent"
            style="max-height: 100%"
            :drawer="false"
        >
            <section class="dialog-body" >
                <h1 class="title">
                    <em>
                        🅰️ 这是调试组件，仅用于调试 
                    </em>
                    <ButtonThe3DButton
                        color="red"
                        size="sm"
                        @click="onLoginClick(false)"
                    >
                        关闭
                    </ButtonThe3DButton>
                </h1>
                <!--
                    ↑ 窗口的 header
                    ↓ 内容主体 
                -->
                <input v-model="sUser" />
                <ButtonThe3DButton color="blue" size="sm"
                    @click="showLink()"
                >
                    生成AU
                </ButtonThe3DButton>
                <div class="top-list">
                    <p class="only-au">
                        {{ sOnlyAU }}
                        <ButtonCopy :value="sOnlyAU"></ButtonCopy>
                    </p>
                    <a class="block my-2" v-if="sUserLink" :href="sUserLink">
                        {{sUserLink || '暂无'}}
                    </a>
                    <template v-for="(cur, idx) of aAllGames">
                        <br v-if="cur.gName === 'br'" />
                        <span v-else
                            class="one-game"
                        >   
                            <a :href="cur.link"> 
                                {{ cur.gName }}
                            </a>、
                        </span>
                    </template>
                </div>
                
                <hr class="hr"/> 
                <p>--- 👇 一键登录 -------------</p>
                <ul class="ul">
                    <li v-for="oUser of aUser">
                        <a :href="oUser.sLink">
                            🚹
                            {{ oUser.name }}
                            {{ oUser.sLink ? '' : '⏳' }} 
                        </a>
                    </li>
                </ul>
                <p class="opacity-60 text-xs">
                    所有链接仅可单次使用，用后失效。
                    <br/>为同一用户生成多个链接的，最后一个次生成的链接有效。 
                </p>
            </section>
        </Modal>
    </div>
</template>

<script lang="ts" setup>
import useGlobalStore from '~/stores/global';

const globalStore = useGlobalStore();
const sRandomUserX = '随机用户';
const sUser = ref('');
const sOnlyAU = ref('');
const sUserLink = ref('');
const aUser = ref([]);
const aAllGames = ref([]);

const onLoginClick = (val) => {
    globalStore.loginDialogIsOpen = !!val; 
};

const showLink = async (oDefault=void 0)=>{
    let au = ''; 
    if (oDefault){
        sUser.value = oDefault.user;
        au = oDefault.au;
    }else{
        sUser.value = sUser.value.trim() || 'test001';
        au = await getAU(sUser.value);
    }
    sOnlyAU.value = au;
    sUserLink.value = au2link(au);
    aAllGames.value = aGameList.map(sGameName => {
        const gName = sGameName.replace(/game$/i, '');
        return {
            gName,
            link: `/cn/casino/${sGameName}/?au=${au}`,
        };
    });
    if (oDefault) return;
    aUser.value.find(cur=>{
        if (cur.name === sUser.value){
            cur.name = '已失效 ✘';
        }
    });
}

const au2link = (au)=>{
    const {origin} = location;
    const sLink = `${origin}/?au=${au}`;
    return sLink;
}

// ↓ 生成一个用户的 au 值 
async function getAU(userName){
    let formData = new FormData();
    formData.append("uid", userName);
    formData.append("api_id", 'FDB6D767D2F8E');
    // 这个地址在 nuxt.config.ts 配置了代理，真实地址：http://13.215.6.142:8880/getTestLink0606
    const sAU = await fetch('/getTestLink0606', {
        method: 'POST',
        body: formData,
    }).then(response => {
        return response.json();
    }).then((response) => {
        return response.code;
    }).catch((error) => {
        console.error('Error:', error);
        return false;
    });
    return sAU;
}



watch(
    ()=>globalStore.loginDialogIsOpen,
    async (newValue)=>{
        if (!newValue || !import.meta.client) {
            return; 
        }
        sUserLink.value = '';
        aUser.value = aUsersHaveMoney.map(name => {
            return {
                name,
                sLink: '',
            };
        });
        for(const [idx, curUser] of aUser.value.entries()){
            if (idx % 2) await Sleep(20); 
            let au = '';
            if (curUser.name === sRandomUserX){
                // 这是随机登录功能，接口在这里声明： server\routes\testLogin.ts 
                const oRes = await $fetch(
                    '/testLogin',
                    { method: 'POST' },
                );
                au = oRes?.['au'];
            }else{
                au = await getAU(curUser.name);
            }
            if (!au) return;
            curUser.sLink = au2link(au);
            if (idx === 0){ // 顶部的默认用户 
                showLink({
                    au,
                    user: curUser.name,
                }); 
            }
        }
    },
);

// ====== ↓ 一些数据 ======================================================== 

// ↓ 注册用户列表（用户1和5是有余额的 
const aUsersHaveMoney = [
    'test001', 'test002', 'test003', 'test004', 'test005',
    'test006', 'test007', 'test008', 'test009', 'test010',
    // 在此随意添加...  
    sRandomUserX,
];

// ↓ 游戏列表 
const aGameList = [ 
    // `${prefix}/cn/casino/crashGame`,
    `diceGame`,
    `spacediceGame`,
    `hiloGame`,
    `futuresGame`,
    'br',
    `kenoGame`,
    `minesGame`,
    `crashGame`,
    `rouletteGame`,
    'br',
    `blackjackGame`,
    `corgipharaohGame`,
    'br',
    // -------------------- 
    `plinkoGame`,
    `coinflipGame`,
    `limboGame`,
    `ringGame`,
    `cryptosGame`,
    'br',
    `tripleGame`,
    `circleGame`,
    `stairsGame`,
    `towerGame`,
    `corgiwildGame`,
    'br',
    // -------------------- 
    `redpacketGame`,
    `niuniuGame`,
    `zhajinhuaGame`,
    `jisuhajinhuaGame`,
];
</script>

<style lang="scss" scoped>
.dialog-body {
    padding: 20px;
    background-color: rgb(27, 38, 54);
    color: white;
}
input{
    color: black;
    padding: 3px 5px;
}

.title{
    line-height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 25px;
}
.hr{
    margin: 15px 0 20px; 
    height: 2px;
}

.ul{
    padding: 8px 0 20px; 
    display: flex;
    flex-wrap: wrap;
    li {
        width: 100px;
        line-height: 25px;
    }
    a {
        white-space: nowrap; 
        &:hover{
            text-decoration: underline;
        }
    }
}

.top-list{
    .only-au{
        margin-top: 12px;
        display: flex;
        align-items: center;
        button{
            margin: 0 auto 0 2px;
        }
    }
    a{
        cursor: pointer;
        &:hover{
            text-decoration: underline; 
        }
    }
    .one-game{
        display: inline-block;
        &:nth-of-type(4n + 1){
            margin-right: auto;
        }
    }
}

</style>

